<template>
<div v-if="!redirectToThirdParty">
    <h5 class="mt-2 text-center">Enter your card details to pay</h5>

    <div class="modal-body">
        <form class="form" ref="cardForm" data-bitwarden-watching="1" @submit.prevent="$emit('triggerPayment')">

            <p id="mpgs-loading-message" class="text-center" style="-webkit-animation: blinker 0.5s linear infinite;animation: blinker 0.5s linear infinite;">Loading please wait..</p>

            <div class="row mx-0">
                <div class="col-12 px-0">
                    <div class="form-group" ref="cardFormGroup" :class="removeMargin ? 'mb-2' : ''">
                        <label for="card_cc">Card Number</label>

                        <the-mask :mask="['#### #### #### #### ###']" v-model="card_cc" id="card_cc" ref="card_cc" class="card_number cc-masked form-control " placeholder="0000 0000 0000 0000 000" title="Enter your card number" data-exception="cc" data-valid-example="5063 5232 3523 2533 234" required autofocus @focus.native="card_cc_hover = true" max-length="19" @blur.native="card_cc_hover = false" :style="{ borderColor: (card_cc_hover ? ccBorderColor : borderColor) }" readonly />
                        <span class="invalid-feedback" :style="(errors.card_cc) ? 'display : inline' : ''">Invalid card number</span>
                    </div>
                </div>
            </div>

            <div class="row m-0" :class="!showToken ? 'mb-2': ''">
                <div class="col-sm-4 col-4">
                    <div class="form-group" ref="expiryFormGroup" style="margin-right:5px" :class="removeMargin ? 'mb-2' : ''">
                        <label for="card_exp_month">Month</label>
                        <the-mask :mask="['##']" v-model="card_exp_month" id="card_exp_month" ref="card_exp_month" class="form-control" placeholder="MM" required @focus.native="card_exp_month_hover = true" max-length="2" @blur.native="card_exp_month_hover = false" :style="{ borderColor: (card_exp_month_hover ? expMonthBorderColor : borderColor)  }" readonly />
                        <span class="invalid-feedback" :style="(errors.card_exp_month) ? 'display : inline' : ''">Invalid expiry month</span>
                    </div>
                </div>

                <div class="col-sm-4 col-4 px-0">
                    <div class="form-group" ref="expiryFormGroup" style="margin-right:5px" :class="removeMargin ? 'mb-2' : ''">
                        <label for="card_exp_year">Year</label>
                        <the-mask :mask="['##']" v-model="card_exp_year" id="card_exp_year" ref="card_exp_year" class="form-control" placeholder="YY" required @focus.native="card_exp_year_hover = true" max-length="2" @blur.native="card_exp_year_hover = false" :style="{ borderColor: (card_exp_year_hover ? expYearBorderColor : borderColor)  }" readonly />
                        <span class="invalid-feedback" :style="(errors.card_exp_year) ? 'display : inline' : ''">Invalid expiry year</span>
                    </div>
                </div>

                <div class="col-sm-4 col-4 px-0">
                    <div class="form-group" ref="cvvFromGroup" :class="removeMargin ? 'mb-2' : ''">
                        <label for="card_cvv">CVV</label>
                        <the-mask :mask="['###']" v-model="card_cvv" id="card_cvv" ref="card_cvv" class="form-control" placeholder="123" required="" title="Enter your card cvv" @focus.native="card_cvv_hover = true" max-length="3" @blur.native="card_cvv_hover = false" :style="{ borderColor : (card_cvv_hover ? cvvBorderColor : borderColor) }" readonly />
                        <span class="invalid-feedback" :style="(errors.card_cvv) ? 'display : inline' : ''">Invalid card CVV</span>
                    </div>
                </div>
            </div>

            <div class="row m-0 ">
                <div v-if="showToken" class="col-12 px-0 mb-3">
                    <div class="mt-1 custom-checkbox py-2" style="cursor: pointer;">
                        <input v-if="enforce_tokenization" type="checkbox" class="custom-control-input" id="tokenize-card" title="Tokenize Card" :checked="enforce_tokenization" disabled>
                        <input v-else type="checkbox" class="custom-control-input" id="tokenize-card" title="Tokenize Card">
                        <label class="custom-control-label ml-3 py-2" :for="enforce_tokenization ? 'nothing':'tokenize-card'" style="color:#7b797b; cursor: pointer;" title="Tokenize Card">
                            Save card information
                        </label>
                    </div>
                </div>

                <div class="col-12 px-0">
                    <div class="form-group mb-0">
                        <button type="submit" class="btn app-bg-color" :style="button_color" ref="btnActionPay" id="btnActionPay">
                            Make Payment
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div v-else class="text-center">
    <h4 class="mb-3 my-5 mx-auto">You will be redirected to your card's issuer's verification page to authorize this payment</h4>
    <!-- <button type="submit" class="viabutton submit mb-3" @click.prevent="visitThirdParty">Proceed</button>
        <a href="javascript:void(0)" class="change-option" @click.prevent="cancelRedirect"> Cancel </a> -->
</div>
</template>

<script>
/* eslint-disable */
import {
    TheMask
} from 'vue-the-mask'

export default {
    props: {
        scriptLoaded: {
            type: Promise,
            required: true,
        },
        redirectToThirdParty: {
            type: Boolean,
            required: true,
            default: false,
        },
        extras: {
            type: Object,
            required: true,
        },
        button_color: {
            type : Object,
            required: true,
        },
        mpgsSdkUrl : {
            type : String,
            required: true,
        }

    },
    components: {
        TheMask,
    },

    destroyed() {
        let el = document.querySelector(`script[src='${this.mpgsSdkUrl}']`);
        if (el) {
            el.remove();
        }
    },

    updated() {
        // Look for a way to prevent re initialization
        if (!this.loading) {
            if (this.showToken && !this.enforce_tokenization) {
                if (this.checkToken)
                    if (document.getElementById('tokenize-card')) {
                        document.getElementById('tokenize-card').checked = true;
                    }
            }

            this.updatedIntegration();

        } else { // know that user is calling OnePipe
            if (this.isCallingOnePipe) {
                PaymentSession.updateSessionFromForm('card');
            }
        }

    },
    mounted() {
        this.provider = this.$store.state.provider

        if (Object.keys(this.provider.extras).includes("enforce_tokenization")) {
            if (this.provider.extras.enforce_tokenization == "true") {
                this.showToken = true;
                this.enforce_tokenization = true;
            } else {
                if (Object.keys(this.provider.extras).includes("allow_tokenization")) {
                    if (this.provider.extras.allow_tokenization == "true") {
                        this.checkToken = true; // automatically check the tokenization box
                        this.showToken = true;
                    } else if (this.provider.extras.allow_tokenization == "") {
                        this.checkToken = false;
                        this.showToken = true;
                    }

                }
            }
        }
    },
    data() {
        return {
            card_cc: '',
            card_exp: '',
            card_exp_month: '',
            card_exp_year: '',
            card_cvv: '',
            borderColor: '#e4e4e4',
            ccBorderColor: '',
            expBorderColor: '',
            expMonthBorderColor: '',
            expYearBorderColor: '',
            cvvBorderColor: '',
            card_cc_hover: true,
            card_exp_year_hover: false,
            card_exp_month_hover: false,
            card_exp_hover: false,
            card_cvv_hover: false,
            isVerve: false,
            mpgsIsReady: false,
            loading: true,
            removeMargin: false,
            showToken: false,
            enforce_tokenization: false,
            checkToken: false,
            provider: null,
            errors: {
                card_cc: false,
                card_exp: false,
                card_exp_month: false,
                card_exp_year: false,
                card_cvv: false,
            },
        }
    },
    methods: {
        pickCardToDelete(val) {
            this.$emit('pickCardToDelete', val);
        },
        handleAttemptCardRemoval(val) {
            this.$emit('handleAttemptCardRemoval', val);
        },
        gotoCardListing() {
            this.$emit('gotoCardListing');
        },
        triggerCardInput() {
            this.$emit('triggerCardInput');
        },
        triggerManageCard() {
            this.$emit('triggerManageCard');
        },

        isLoading(val = false) {
            this.$emit('isLoading', val);
        },
        integration() {
            this.scriptLoaded && this.scriptLoaded.then(() => {

                let vm = this;
                this.isLoading();

                PaymentSession.configure({
                    fields: {
                        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
                        card: {
                            number: "#card_cc",
                            securityCode: "#card_cvv",
                            expiryMonth: "#card_exp_month",
                            expiryYear: "#card_exp_year"
                        }
                    },
                    //SPECIFY YOUR MITIGATION OPTION HERE
                    frameEmbeddingMitigation: ["javascript"],
                    callbacks: {
                        initialized: (response) => { // HANDLE INITIALIZATION RESPONSE
                            if (response.status == "ok") {
                                this.isLoading();
                                vm.removeMargin = true;
                                vm.mpgsIsReady = true;

                                if (document.getElementById('mpgs-loading-message')) {
                                    document.getElementById('mpgs-loading-message').style.display = 'none';
                                    vm.mpgsIsReady = true;
                                }
                            }
                        },
                        formSessionUpdate: (response) => { // HANDLE RESPONSE FOR UPDATE SESSION

                            if (response.status) {
                                if ("ok" == response.status) {
                                    vm.$emit('callOnePipe', response.session.id)
                                } else if ("fields_in_error" == response.status) {

                                    this.isLoading();

                                    if (response.errors.cardNumber) {
                                        vm.errors.card_cc = true
                                    }
                                    if (response.errors.expiryYear) {
                                        vm.errors.card_exp_year = true
                                    }
                                    if (response.errors.expiryMonth) {
                                        vm.errors.card_exp_month = true
                                    }
                                    if (response.errors.securityCode) {
                                        vm.errors.card_cvv = true;
                                    }

                                } else if ("request_timeout" == response.status) {
                                    alert("Session update failed with request timeout: " + response.errors.message);
                                } else if ("system_error" == response.status) {
                                    alert("Session update failed with system error: " + response.errors.message);
                                }
                            } else {
                                alert("Session update failed: " + response);
                            }
                        }
                    }
                });
            });
        },

        updatedIntegration() {
            this.scriptLoaded && this.scriptLoaded.then(() => {

                let vm = this;

                PaymentSession.configure({
                    // window.PaymentSession.configure({
                    fields: {
                        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
                        card: {
                            number: "#card_cc",
                            securityCode: "#card_cvv",
                            expiryMonth: "#card_exp_month",
                            expiryYear: "#card_exp_year"
                        }
                    },
                    //SPECIFY YOUR MITIGATION OPTION HERE
                    frameEmbeddingMitigation: ["javascript"],
                    callbacks: {
                        initialized: (response) => { // HANDLE INITIALIZATION RESPONSE
                            if (response.status == "ok") {
                                vm.loading = false;
                                vm.removeMargin = true;
                                vm.mpgsIsReady = true;

                                if (document.getElementById('mpgs-loading-message')) {
                                    document.getElementById('mpgs-loading-message').style.display = 'none';
                                    vm.mpgsIsReady = true;
                                }
                            }
                        },
                        formSessionUpdate: (response) => { // HANDLE RESPONSE FOR UPDATE SESSION
                            if (response.status) {
                                if ("ok" == response.status) {
                                    vm.callOnePipe(response.session.id);
                                } else if ("fields_in_error" == response.status) {

                                    vm.loading = false;

                                    if (response.errors.cardNumber) {
                                        vm.errors.card_cc = true
                                    }
                                    if (response.errors.expiryYear) {
                                        vm.errors.card_exp_year = true
                                    }
                                    if (response.errors.expiryMonth) {
                                        vm.errors.card_exp_month = true
                                    }
                                    if (response.errors.securityCode) {
                                        vm.errors.card_cvv = true;
                                    }

                                } else if ("request_timeout" == response.status) {
                                    alert("Session update failed with request timeout: " + response.errors.message);
                                } else if ("system_error" == response.status) {
                                    alert("Session update failed with system error: " + response.errors.message);
                                }
                            } else {
                                alert("Session update failed: " + response);
                            }
                        }
                    }
                });
            });
        },
    },
}
</script>
